import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TestViewComponent } from './test-view/test-view.component';
import { GridModule } from '@grid/grid.module';
import { InputModule } from '@input/input.module';
import { GridCellModule } from '../grid-cell/grid-cell.module';
import { DeleteDocumentComponent } from "@grid-cell/delete-document.component";
import { DownloadDocumentComponent } from "@grid-cell/download-document.component";
import { EmailDialogButtonComponent } from "@grid-cell/email-dialog-button.component";
import { PrintDocumentComponent } from "@grid-cell/print-document.component";
import { ViewDocumentComponent } from "@grid-cell/view-document.component";



@NgModule({
  declarations: [TestViewComponent],
  imports: [
    CommonModule,
    GridModule,
    InputModule,
    GridCellModule,
    DeleteDocumentComponent,
    DownloadDocumentComponent,
    EmailDialogButtonComponent,
    PrintDocumentComponent,
    ViewDocumentComponent
],
  exports:[
    TestViewComponent
  ]
})
export class TestGuiModule { }
